<template>
    <div>
      <div class="inner-header">
        <nav class="navbar fixed-top animate__animated animate__slideInRight" style="border: 1px solid #f4f4f4 !important;">
          <a  @click="$router.go(-1)" class="back-arrow">
              <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
                 <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                    <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2"/>
                    <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2"/>
                 </g>
              </svg>
           </a>
          <a href="javascript:void(0);" class="link-title">Enquiry Details</a>
        </nav>
      </div>
      <div class="inner-page animate__animated animate__slideInRight">
          <div class="container-fluid">
              <div class="row">
                  <!-- Enquiry Card -->
                  <div class="col-12">
                      <div class="card details-card">
                          <div class="card-header">
                              <div class="row">
                                  <div class="col-7">
                                      <span class="lead-title" v-if="GetEnquiriesDetails.broker_firm_name">{{GetEnquiriesDetails.broker_firm_name}}</span>
                                      <span class="sub-title" v-if="GetEnquiriesDetails.building_name">{{GetEnquiriesDetails.building_name}}</span>
                                  </div>
                                  <div class="col-5 text-right" v-if="GetEnquiriesDetails.deleted_at">
                                      <span class="label-status">{{'Deleted'}}</span>
                                  </div>
                              </div>
                          </div>
                          <div class="card-body">
                              <div class="row">
                                  <div class="col-6" v-if="GetEnquiriesDetails.executive_name">
                                      <span class="enq-title">Field Executive</span>
                                      <span class="enq-details">{{GetEnquiriesDetails.executive_name}}</span>
                                  </div>
                                  <div class="col-6">
                                      <span class="enq-title">Booked?</span>
                                      <span class="enq-details">{{GetEnquiriesDetails.booking_done ? GetEnquiriesDetails.booking_done : '-'}}</span>
                                  </div>
                                  <div class="col-6">
                                      <span class="enq-title">Site Visit Done</span>
                                      <span class="enq-details">{{GetEnquiriesDetails.site_visit_done ? GetEnquiriesDetails.site_visit_done : '-'}}</span>
                                  </div>
                                  <div class="col-6">
                                      <span class="enq-title">Site Visit Date</span>
                                      <span class="enq-details">{{GetEnquiriesDetails.visit_date ? GetEnquiriesDetails.visit_date : '-'}}</span>
                                  </div>
                                  <div class="col-6">
                                      <span class="enq-title">Created at</span>
                                      <span class="enq-details">{{GetEnquiriesDetails.created_at ? GetEnquiriesDetails.created_at : '-'}}</span>
                                  </div>
                                  <div class="col-6">
                                      <span class="enq-title">Approved?</span>
                                      <span class="enq-details">{{GetEnquiriesDetails.approved ? 'Yes' : 'No'}}</span>
                                  </div>
                                  <div class="col-6">
                                      <span class="enq-title">EOI Done</span>
                                      <span class="enq-details">{{GetEnquiriesDetails.eoi_done ? GetEnquiriesDetails.eoi_done : '-'}}</span>
                                  </div>
                                  <div class="col-6">
                                      <span class="enq-title">EOI Done Date</span>
                                      <span class="enq-details">{{GetEnquiriesDetails.eoi_done_date ? GetEnquiriesDetails.eoi_done_date : '-'}}</span>
                                  </div>
                                  <div class="col-6">
                                      <span class="enq-title">EOI Approved?</span>
                                      <span class="enq-details">{{GetEnquiriesDetails.eoi_approved ? 'Yes' : 'No'}}</span>
                                  </div>
                                  <div class="col-6">
                                      <span class="enq-title">Booking Done Date</span>
                                      <span class="enq-details">{{GetEnquiriesDetails.booking_done_date ? GetEnquiriesDetails.booking_done_date : '-'}}</span>
                                  </div>
                                  <div class="col-6">
                                      <span class="enq-title">Delete Date</span>
                                      <span class="enq-details">{{GetEnquiriesDetails.deleted_at ? GetEnquiriesDetails.deleted_at : '-'}}</span>
                                  </div>
  
                              </div>
                          </div>
                      </div>
                      <div class="card details-card">
                          <div class="card-body">
                            <div class="row">
                                <div class="col-6">
                                  <span class="enq-details">Site Visit Form</span>
                                </div>
                                <div class="col-6 text-right">
                                  <button @click="ViewSV(GetEnquiriesDetails.site_visit_form_url)" :disabled="!GetEnquiriesDetails.site_visit_form_url" class="btn btn-primary h-auto"> <img src="@/assets/visibility.svg" width="16" height="16"
                                      alt="" class="m-fix mr-1"/> View</button>
                                </div>
                              </div>
                              <div class="row  mt-2" v-if="!GetEnquiriesDetails.deleted_at">
                                <div class="col-6">
                                  <span class="enq-details">EOI Done Form</span>
                                </div>
                                <div class="col-6 text-right">
                                  <button :disabled="!GetEnquiriesDetails.eoi_done_form"  @click="ViewEOI(GetEnquiriesDetails.eoi_done_form)" class="btn btn-primary h-auto"> <img src="@/assets/visibility.svg" width="16" height="16"
                                      alt="" class="m-fix mr-1"/> View</button>
                                </div>
                              </div>
                              <div class="row mt-2" v-if="!GetEnquiriesDetails.deleted_at">
                                <div class="col-6">
                                  <span class="enq-details">Booking Done Form</span>
                                </div>
                                <div class="col-6 text-right">
                                  <button :disabled="!GetEnquiriesDetails.booking_done_form" @click="ViewBookingForm(GetEnquiriesDetails.booking_done_form)" class="btn btn-primary h-auto"> <img src="@/assets/visibility.svg" width="16" height="16"
                                      alt="" class="m-fix mr-1" /> View</button>
                                </div>
                              </div>
                          </div>
                      </div>
                    <div class="card-btn" v-if="!GetEnquiriesDetails.deleted_at">
                      <div class="row">
                        <div class="col-12 mb-3">
                          <router-link :to="{ name: 'SiteVisit', params: { id: GetEnquiriesDetails.id }}" class="btn btn-primary btn-block"> <img
                               alt="" class="m-fix mr-1" /> Edit
                            Site Visit</router-link>
                        </div>
                        <div class="col-12 mb-3">
                          <router-link :to="{ name: 'Eoi', params: { id: this.$route.params.id }}" class="btn btn-primary btn-block"> <img
                               alt="" class="m-fix mr-1" />
                               Edit EOI</router-link>
                        </div>
                        <div class="col-12 mb-3">
                        <router-link :to="{ name: 'AddNewMeeting', params: { id: this.$route.params.id }, query: {name: 'pr_enquiry'}}" class="btn btn-primary btn-block"> <img
                             alt="" class="m-fix mr-1" />
                             Add Meeting</router-link>
                      </div>
                      </div>
                    </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </template>
  <script>
  export default {
    name: 'Details',
    data() {
      return {
        queryP: {},
        CallStatus: null,
        roleId: localStorage.getItem('radiate-crm-role_id'),
        GetEnquiriesDetails: {}
      }
    },
    created () {
      this.FetchEnquiriesDetails()
    },
    methods: {
      ViewEOI(eoi) {
        window.open(eoi)
      },
      ViewSV(sv) {
        window.open(sv)
      },
      ViewBookingForm(Booking_form) {
        window.open(Booking_form)
      },
      FetchEnquiriesDetails() {
          this.queryP['id'] = this.$route.params.id;
          this.$axios.get(`premium_enquiries/${this.queryP.id}`, { params: this.queryP }).then((res) => {
          this.GetEnquiriesDetails = res.data.premium_enquiry;
        });
      },
    }
  }
  </script>
  <style scoped>
      .inner-page{
          margin-top: 60px;
      }
      .call-loading-holder img{
          max-width: 500px;
          margin:0 auto;
          display: table;
      }
      .form-card input {
        background: #F6F6F6 !important;
        border: 0px solid #D0D0D0 !important;
        border-radius: 6px !important;
        font-weight: 500 !important;
        font-size: 14px !important;
        min-height: 0px !important;
        width: 100%  !important;
        padding: 10px !important;
      }
      .details-card .card-header .label-status {
        font-weight: 600;
        font-size: 14px;
        letter-spacing: 0.02em;
        color: red;
        background: #F6F6F6;
        border-radius: 18px;
        padding: 6px 14px;
        display: inline-block;
        text-align: center;
    }
  </style>